import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { StudentComment } from './student-comment.model';
import { StudentCommentService } from './student-comment.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'jhi-student-comment-detail',
    templateUrl: './student-comment-detail.component.html'
})
export class StudentCommentDetailComponent implements OnInit, OnDestroy {

    studentComment: StudentComment;
    private subscription: any;
    private StudentCommentSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private StudentCommentService: StudentCommentService,
        private eventManager: EventManager,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['student-comment']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.StudentCommentSubscription = this.eventManager
        .subscribe('StudentCommentListModification',
        (response) => {
            this.studentComment = response['content']['content'];
        });
    }

    load(id) {
        this.StudentCommentService.find(id).subscribe(StudentComment => {
            this.studentComment = StudentComment;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.StudentCommentSubscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment-detail.component.ts